import { useState } from "react";
import ReplayIcon from "@mui/icons-material/Replay";
import { Box, CircularProgress } from "@mui/material";

import Layout from "../../templates/Layout"; // Layoutコンポーネントをインポート
import LogTable from "./LogTable";
import Button from "../../Button/Button";
import { Progress } from "../../templates/Progress";
import { useListCleaningEventByRobotQuery } from "hooks/worker/useCleaningEvent";
import { useListMapQuery } from "hooks/worker/useMap";
import { callSyncCleaningEvent } from "api/worker/cleaningEvent";
import { notify } from "lib/notify";
import { handleError } from "utils/error/handleError";
import { useSafeQueryId } from "hooks/useSafeId";
import { useListRobotQuery } from "hooks/worker/useRobot";

const CleaningLog = () => {
  const robotId = useSafeQueryId("id");
  const { data: robots } = useListRobotQuery();
  const robot = robots?.find((r) => r.robotId === robotId);

  const { data: logs = [], refetch: refetchLogs } =
    useListCleaningEventByRobotQuery({ robotId });
  const { data: maps = [], refetch: refetchMaps } = useListMapQuery();
  const [loading, setLoading] = useState(false);

  const onRefetch = async () => {
    await Promise.all([refetchLogs(), refetchMaps()]);
  };

  const onClickSync = async () => {
    setLoading(true);
    try {
      await callSyncCleaningEvent();
      await onRefetch();
      notify("更新しました");
    } catch (e) {
      handleError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title={`${robot?.robotName || ""} 清掃ログ`}>
      <Box sx={{ display: "flex", mb: 1 }}>
        <Button
          onClick={onClickSync}
          variant="outlined"
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <ReplayIcon />
            )
          }
          sx={{ ml: "auto" }}
        >
          再取得
        </Button>
      </Box>

      {logs.length > 0 && (
        <Box sx={{ position: "relative" }}>
          <LogTable
            logs={logs}
            maps={maps}
            refetchFunc={onRefetch}
            enableMapName
            enableMenu
          />
          <Progress enabled={loading} />
        </Box>
      )}
    </Layout>
  );
};

export default CleaningLog;
